<template>
  <div class="hdf-home-wrapper" ref="wrapperRef">
    <div class="hdf-home" ref="homeRef">
    <!-- ===================== 顶部导航（新版蓝色通栏组件） ===================== -->
    <HDFHeader03 />

    <!-- 滚动通知条（老逻辑：有通知才显示） -->
    <!-- <NotificationBar
      v-if="configState.noticeList.value.length > 0"
      :notifications="configState.noticeList.value"
      :interval="3000"
      @close="handleNoticeClose"
      @click="handleNoticeClick"
    /> -->

    <main class="page-main">
      <!-- ===================== Hero 区 ===================== -->
      <section class="hero">
        <!-- ===================== 右侧悬浮工具条 ===================== -->
        <div class="float-toolbar">
          <el-popover placement="left" width="auto" trigger="click">
            <template #reference>
              <div class="float-item">
                <img class="icon-z" src="@/assets/images/v2/icon-z-001.png" alt="活动说明" />
                <span>活动说明</span>
                <span class="float-en">Description</span>
              </div>
            </template>
            <div class="float-pop">敬请期待</div>
          </el-popover>

          <el-popover placement="left" width="auto" trigger="click">
            <template #reference>
              <div class="float-item">
                <img class="icon-z" src="@/assets/images/v2/icon-z-002.png" alt="添加微信" />
                <span>添加微信</span>
                <span class="float-en">Wechat</span>
              </div>
            </template>
            <div class="float-pop qr-pop">
              <img src="@/assets/images/banner-item-wechat2.jpg" alt="微信二维码" />
            </div>
          </el-popover>

          <el-popover placement="left" width="auto" trigger="click">
            <template #reference>
              <div class="float-item">
                <img class="icon-z" src="@/assets/images/v2/icon-z-003.png" alt="联系我们" />
                <span>联系我们</span>
                <span class="float-en">Contact</span>
              </div>
            </template>
            <div class="float-pop tel-pop">400-775-5269</div>
          </el-popover>
        </div>

        <div class="hero-left">
          <!-- 新版：左侧不再用整图，改为代码文字 -->
          <img class="hero-logo" src="@/assets/images/v2/hdf_logo_02.png" alt="慧得分" />
          <div class="hero-tags">
            <div class="hero-tag">青少年终身成长的AI伙伴</div>
            <div class="hero-tag">人工智能教育助手</div>
          </div>
          <div class="hero-lines">
            <p><b>智领AI</b><span>·</span><b>智能引领生涯规划</b></p>
            <p><b>问思AI</b><span>·</span><b>提问思辨辅助学习</b></p>
            <p><b>澄智AI</b><span>·</span><b>澄清认知助力教学</b></p>
          </div>
        </div>
        <div class="hero-right">
          <!-- 轮播图（老逻辑：getIndexBannerList 接口取数，el-carousel 轮播） -->
          <el-carousel
            v-if="bannerList.length > 0"
            class="hero-carousel"
            arrow="never"
            height="640px"
          >
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
              <img class="hero-banner-img" :src="item.img" />
            </el-carousel-item>
          </el-carousel>
          <div v-else class="hero-img-placeholder">
            <span>主图占位</span>
            <span class="placeholder-sub">第二阶段接首页轮播接口</span>
          </div>
        </div>
      </section>

      <!-- ===================== 吉祥物 + 合作方（新版组件：精灵图左浮 + logo 横条） ===================== -->
      <HDFPartnerBar03 />

      <!-- ===================== 科创研究 ===================== -->
      <section class="feature-card">
        <div class="feature-img">
          <!-- <img src="@/assets/images/home-new/section-innovation.jpg" alt="科创研究" /> -->
          <img src="@/assets/images/v2/section-innovation-02.png" alt="科创研究" />
        </div>
        <div class="feature-body">
          <!-- <div class="feature-brands">
            <img src="@/assets/images/site-name-02.png" alt="慧得分" />
            <span class="brand-divider"></span>
            <span class="brand-name">Wilmer</span>
            <span class="brand-divider"></span>
            <span class="brand-name">思思编程</span>
            <span class="brand-divider"></span>
            <span class="brand-name">用AI创力</span>
          </div> -->
          <h2 class="feature-title">科学探究、建模实践与具身智能：<br />面向未来的青少年核心能力</h2>
          <div class="feature-tag">科学探究｜建模实践｜工程创新｜AI协同学习</div>
          <p class="feature-desc">
            面向人工智能与具身智能快速发展的未来，慧得分为教师提供课程设计、探究引导、过程评价与个性化教学支持，助力教师培养学生围绕真实问题开展科学探究与工程实践的能力。学生在提出问题、形成假设、验证方案和持续改进的过程中，逐步提升科学思维、建模能力、创新意识及社会责任感，为未来学习和科技发展奠定扎实基础。
          </p>
        </div>
      </section>

      <!-- ===================== 国际教育资源 ===================== -->
      <section class="feature-card reverse">
        <div class="feature-body">
          <!-- <div class="feature-brands">
            <img src="@/assets/images/site-name-02.png" alt="慧得分" />
            <span class="brand-divider"></span>
            <span class="brand-name">未来AI·智领</span>
          </div> -->
          <h2 class="feature-title">慧得分如何连接全球赛事、 <br />国际荣誉与升学发展</h2>
          <div class="feature-tag">国际赛事｜荣誉认证｜全球研学｜升学发展</div>
          <p class="feature-desc">
            慧得分以国际赛事为实践平台，帮助学生持续积累竞赛成果、工程经验、学术表现与社区服务经历，并衔接国际机器人荣誉学会（IRHS）荣誉体系。同时，通过GLOBAL HONORS全球荣誉项目，整合韩国、美国及欧洲的高校与教育资源，为学生提供国际营地、研究实践、荣誉申请和奖学金机会，帮助具有科技特长的学生建立更加清晰的全球成长与升学发展路径。
          </p>
        </div>
        <div class="feature-img">
          <img src="@/assets/images/v2/img203-02.png" alt="国际教育资源" />
        </div>
      </section>

      <!-- ===================== 数据统计 ===================== -->
      <section class="stats-bar">
        <div class="stat-item">
          <img class="stat-icon" src="@/assets/images/v2/icon-001.png" alt="" />
          <div class="stat-num">5000+</div>
          <div class="stat-line"></div>
          <div class="stat-label">特长学生</div>
        </div>
        <div class="stat-item">
          <img class="stat-icon" src="@/assets/images/v2/icon-002.png" alt="" />
          <div class="stat-num">50+</div>
          <div class="stat-line"></div>
          <div class="stat-label">竞赛等级</div>  
        </div>
        <div class="stat-item">
          <img class="stat-icon" src="@/assets/images/v2/icon-003.png" alt="" />
          <div class="stat-num">100%</div>
          <div class="stat-line"></div>
          <div class="stat-label">全覆盖</div>
        </div>
        <div class="stat-item">
          <img class="stat-icon" src="@/assets/images/v2/icon-004.png" alt="" />
          <div class="stat-num">1000+</div>
          <div class="stat-line"></div>
          <div class="stat-label">名校助教资源</div>
        </div>
      </section>

      <!-- ===================== 视频区（新版独立组件：自带分页+播放弹窗） ===================== -->
      <HDFVideoSection03 />

    </main>
    <!-- ===================== 页脚（新版代码组件） ===================== -->
    <HDFFooter03 />
    <div style="width: 100%; height: 1px;"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { ElMessage } from 'element-plus'
import { getIndexBannerList } from '@/api/index'
import { useConfigStore } from '@/stores'
import { storeToRefs } from 'pinia'
import NotificationBar from '@/components/NotificationBar.vue'
import HDFHeader03 from '@/components/HDFHeader03.vue'
import HDFPartnerBar03 from '@/components/HDFPartnerBar03.vue'
import HDFFooter03 from '@/components/HDFFooter03.vue'
import HDFVideoSection03 from '@/components/HDFVideoSection03.vue'

import { GetUserInfo } from '@/api/api.js'
import { getToken } from '@/utils/common'

// ===================== 等比例缩放逻辑 =====================
const wrapperRef = ref(null)
const homeRef = ref(null)
const MAX_WIDTH = 1440 // 界面最大宽度
const SCALE_WIDTH = 1440 // 缩放基准宽度

const updateScale = () => {
  if (!wrapperRef.value || !homeRef.value) return
  
  const screenWidth = window.innerWidth
  
  if (screenWidth < SCALE_WIDTH) {
    // 小于1440px时，按照1440px的设计宽度进行等比例缩放
    const scale = screenWidth / SCALE_WIDTH
    
    // 设置容器高度为缩放后的实际高度
    const homeHeight = homeRef.value.scrollHeight
    wrapperRef.value.style.height = `${homeHeight * scale}px`
    
    // 应用缩放
    homeRef.value.style.transform = `scale(${scale})`
    homeRef.value.style.transformOrigin = 'top left'
    homeRef.value.style.margin = '0'
    homeRef.value.style.maxWidth = 'none'
  } else {
    // 大于等于1400px时，保持最大宽度1300px并居中
    wrapperRef.value.style.height = 'auto'
    homeRef.value.style.transform = 'none'
    homeRef.value.style.margin = '0 auto'
    homeRef.value.style.maxWidth = `${MAX_WIDTH}px`
  }
}

// ===================== 老导航逻辑（与 HDFHeader2 一致） =====================
const configStore = useConfigStore()
const configState = storeToRefs(configStore)

// 通知条
const handleNoticeClose = () => {}
const handleNoticeClick = (notice) => {
  if (notice && notice.url) {
    window.open(notice.url, '_blank')
  }
}

// 轮播图（老逻辑：与 HDFHome 一致，getIndexBannerList 接口取数）
const bannerList = ref([])

const getBannerList = () => {
  getIndexBannerList().then(response => {
    const res = response.data
    if (res.code == 200) {
      bannerList.value = res.data
    }
  })
}

onMounted(() => {
  getBannerList()

  // 静默获取用户信息，用于刷新头部登录状态
  const token = getToken();
  if (token) {
    GetUserInfo({}, {}, null, true).then(response => {
      const res = response.data
      if(res.code == 401){
        localStorage.clear()
        configStore.setIsLogin(true)
      }
    });
  }
  
  // 初始化缩放
  updateScale()
  window.addEventListener('resize', updateScale)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateScale)
})
</script>

<style scoped>
/* ===================== 全局 ===================== */
.hdf-home-wrapper {
  width: 100%;
  overflow: hidden;
  position: relative;
  background: #F8F8FC;
}

.hdf-home {
  width: 1440px;
  min-height: 100vh;
  background: #F8F8FC;
  color: #1f2b5b;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transform-origin: top left;
}

.page-main {
  max-width: 1440px;
  margin: 0 auto;
  box-sizing: border-box;
}

/* ===================== 右侧悬浮工具条 ===================== */
.float-toolbar {
  position: absolute;
  right: 56px;
  top: 60%;
  transform: translateY(-50%);
  z-index: 99;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.float-item {
  width: 76px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(31, 43, 91, 0.1);
  padding: 12px 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #1f2b5b;
  cursor: pointer;
  transition: transform 0.2s;
}
.float-item:hover {
  transform: translateX(-4px);
}
.float-en {
  font-size: 7px;
  color: #8a91ad;
}
.float-pop {
  font-size: 15px;
  color: #1f2b5b;
  padding: 4px 8px;
}
.qr-pop img {
  width: 140px;
  height: 140px;
  display: block;
}
.tel-pop {
  font-size: 18px;
  font-weight: 600;
}

/* ===================== Hero 区 ===================== */
.hero {
  height: 600px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 60px 80px 37px;
  border-radius: 30px;
  margin-top: 50px;
}

.hero-left {
  width: 60%;
  flex: 1;
  min-width: 0;
  padding-top: 20px;
}

.hero-logo {
  width: 440px;
  height: auto;
  display: block;
  margin-bottom: 48px;
}

.hero-tags {
  display: flex;
  flex-direction: column;
  gap: 26px;
  margin-bottom: 56px;
}

.hero-tag {
  width: fit-content;
  background: #3A69B4;
  color: #ffffff;
  font-size: 36px;
  font-weight: 600;
  padding: 14px 53px;
  border-radius: 999px;
  letter-spacing: 2px;
}
.hero-lines p {
  font-size: 42px;
  font-weight: 700;
  color: #5D5D5D;
  margin: 18px 0;
  letter-spacing: 2px;
}
.hero-lines p span {
  margin: 0 14px;
  color: #1f2b5b;
}
.hero-right {
  flex-shrink: 0;
  width: 560px;
  height: 640px;
}
.hero-right img {
  width: 100%;
  border-radius: 28px;
  display: block;
  box-shadow: 0 12px 40px rgba(31, 43, 91, 0.12);
}
.hero-img-placeholder {
  width: 100%;
  height: 100%;
  border-radius: 28px;
  background: #ffffff;
  border: 2px dashed #d8dbe8;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #8a91ad;
  font-size: 18px;
  box-shadow: 0 12px 40px rgba(31, 43, 91, 0.08);
}

.hero-carousel {
  width: 100%;
  height: 100%;
  border-radius: 28px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(31, 43, 91, 0.12);
}
.hero-banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0;
  box-shadow: none;
}
.hero-img-placeholder .placeholder-sub {
  font-size: 13px;
  color: #b9bed4;
}
.icon-z {
  width: 50px;
  height: 40px;
}

/* ===================== 特性卡片 ===================== */
.feature-card {
  display: flex;
  align-items: center;
  gap: 60px;
  padding: 60px 10px;
  margin-bottom: 60px;
}
.feature-card.reverse {
  flex-direction: row;
}
.feature-img {
  width: 46%;
  flex-shrink: 0;
  border-radius: 83px;
  box-shadow: 0 4px 16px rgba(31, 43, 91, 0.2);
  overflow: hidden;
}
.feature-img img {
  width: 100%;
  display: block;
}
.feature-body {
  flex: 1;
  min-width: 0;
}
.feature-brands {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}
.feature-brands img {
  height: 28px;
}
.brand-divider {
  width: 1px;
  height: 18px;
  background: #d8dbe8;
}
.brand-name {
  font-size: 15px;
  color: #5a6285;
  font-weight: 500;
}
.feature-title {
  font-size: 42px;
  font-weight: 700;
  color: #4B70B6;
  line-height: 82px;
  margin: 0 0 20px;
}
.feature-tag {
  width: fit-content;
  background: #4B70B6;
  color: #ffffff;
  font-size: 30px;
  padding: 20px 30px;
  border-radius: 999px;
  margin-bottom: 24px;
  letter-spacing: 1px;
}
.feature-desc {
  font-size: 26px;
  color: #424242;
  line-height: 52px;
  margin: 0;
  text-align: justify;
}

/* ===================== 数据统计 ===================== */
.stats-bar {
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(31, 43, 91, 0.06);
  display: flex;
  justify-content: space-around;
  padding: 30px 30px;
  margin-bottom: 60px;
}
.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 200px;
}
.stat-icon {
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin-bottom: 10px;
}
.stat-num {
  font-size: 52px;
  font-weight: 700;
  color: #101839;
  line-height: 70px;
}
.stat-line {
  width: 100%;
  border-top: 2px solid #101839;
  margin: 12px 0;
}
.stat-label {
  font-size: 30px;
  color: #222222;
}

/* ===================== 响应式 ===================== */
/* @media (max-width: 1200px) {
  .hero {
    flex-direction: column;
    align-items: flex-start;
  }
  .hero-right {
    width: 100%;
  }
  .feature-card {
    flex-direction: column;
    padding: 40px;
    gap: 30px;
  }
  .feature-card.reverse {
    flex-direction: column-reverse;
  }
  .feature-img {
    width: 100%;
  }
  .video-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .footer-top {
    flex-direction: column;
    gap: 40px;
  }
  .float-toolbar {
    display: none;
  }
}
@media (max-width: 900px) {
  .nav-left {
    gap: 20px;
  }
  .nav-item {
    font-size: 14px;
  }
  .stats-bar {
    flex-wrap: wrap;
    gap: 30px;
  }
} */

</style>
